import { type Color } from '@mui/material'

export const blue = {
  100: '#0B1924',
  200: '#0A263C',
  300: '#083F6B',
  400: '#05579A',
  500: '#0370C9',
  600: '#0089F8',
  700: '#54AEF8',
  800: '#66B8FB',
  900: '#99D0FC',
} satisfies Partial<Color>
